$(window).on('load', function() {  
  jQuery('.list-menu li a').each(function(index){
      var link = jQuery(this).attr('href');
      jQuery(this).attr('data-link',link);
      jQuery(this).attr('href','javascript:void(0)');
  });
  jQuery('.list-menu li a').click(function(){
        var linkWP = jQuery(this).attr('data-link');
        $.ajax({
          url: "#",
          type: "GET",
          data: {
            param1: ''
          },
          success: function(response) {
            if($(".header__icon--cart .cart-count-bubble").length) {
              const valueSpan = document.querySelector('.header__icon--cart .cart-count-bubble span[aria-hidden=true]').innerHTML;
              if(valueSpan != 0 ){
                var encryptCount = btoa(valueSpan)
                window.location.href = linkWP+`?cs=`+encryptCount;
              }
            }
            else{
              window.location.href = linkWP;
            }
          },
          error: function(xhr, status, error) {
            // handle errors here
          }
        });
  });  
});
function tabTitle(desc, productTabs) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(productTabs).style.display = "block";
  desc.currentTarget.className += " active";
}
// menu script
// Add class on hover
var headerMenuItem = document.querySelector('.header__menu-item');
var headerSubMenu = document.querySelector('.header__submenu');

headerMenuItem.addEventListener('mouseenter', function() {
  headerSubMenu.classList.add('show');
});

// Remove class on mouseout
headerMenuItem.addEventListener('mouseleave', function() {
  headerSubMenu.classList.remove('show');
});

// Submenu hover script

$(document).ready(function() {
  setTimeout(function() {       
        if( $( window ).width() > 989) {
           $('.list-menu__item , .header__submenu').hover(
              function() {
                // Add classes and modify attributes on hover
                $(this).parent().attr('open', true);
                $(this).attr('aria-expanded', true);
              },
              function() {
                // Remove classes and modify attributes on mouseout
                $(this).parent().removeAttr('open');
                $(this).attr('aria-expanded', false);
              }
            );
        }
        else{          
        }
    }, 1000);
});

